import { BaseAlign, Color, Font, Label, Rectangle, ScreenElement, vec } from "excalibur";

const padding = 32;

export class DescriptionBox extends ScreenElement {
    private nameLabel?: Label;
    private descriptionLabel?: Label;
    private costLabel?: Label;

    constructor(x: number, width: number, height: number) {
        super({
            pos: vec(x + padding, padding),
            width: width - padding * 2,
            height: height - padding * 2,
        });
    }

    onInitialize() {
        this.graphics.use(
            new Rectangle({
                color: Color.Transparent,
                height: this.height,
                width: this.width,
            })
        )
    }

    setDescription(name: string, description: string, cost?: number) {
        this.clearDescription();

        this.nameLabel = new Label({
            pos: vec(padding, padding + 24),
            width: this.width - padding * 2,
            text: name,
            font: new Font({
                family: 'Sans-Serif',
                size: 32,
            }),
            color: new Color(255, 255, 255, 1),
        });

        this.descriptionLabel = new Label({
            pos: vec(padding, padding + this.nameLabel.height + 64),
            text: description,
            font: new Font({
                family: 'Sans-Serif',
                size: 28,
                
            }),
            color: new Color(255, 255, 255, 1),
        });

        if (cost) {
            this.costLabel = new Label({
                pos: vec(padding, this.height - padding),
                text: `Cost: $${cost}`,
                font: new Font({
                    family: 'Sans-Serif',
                    size: 28,
                    baseAlign: BaseAlign.Bottom,
                    color: new Color(255, 255, 255, 1),
                })
            });

            this.addChild(this.costLabel);
        }

        this.addChild(this.nameLabel);
        this.addChild(this.descriptionLabel);
    }

    clearDescription() {
        if (this.nameLabel) {
            this.removeChild(this.nameLabel);
            this.nameLabel = null;
        }
        if (this.descriptionLabel) {
            this.removeChild(this.descriptionLabel);
            this.descriptionLabel = null;
        }
        if (this.costLabel) {
            this.removeChild(this.costLabel);
            this.costLabel = null;
        }
    }
}